import { styled, Box } from '@mui/material';
// AiAssistant 的頁尾多一行「系統版本」，markup 與 Resource 不同不便共用元件，
// 但外框樣式相同，改為指向 SiteFooter 的樣式，避免同一份樣式存在兩處。
import { StyledFooter } from '~/components/Global/SiteFooter/SiteFooter.style';

export const internet = {
  container: styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '24px',
    [theme.breakpoints.down('desktop')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('tablet')]: {
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
  })),
};

export const resource = {
  container: styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    width: '100%',
  })),
  stackContainer: styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
    width: '100%',
    padding: '36px',
  })),
  footer: StyledFooter,
};
